import styled from 'styled-components';
import { mediaBreakpointUp } from 'styles/grid';

export const Container = styled.div<{ disabled: boolean; hasLabel: boolean }>`
  ${({ disabled }) => disabled && 'background: rgba(0, 0, 0, 0.04);'}
  border: 1px solid ${({ theme }) => theme.configs.secondaryBox.fontColor};
  border-radius: 4px;
  padding: 12px;

  display: grid;
  gap: 16px;

  grid-template-columns: 24px 80px 150px 70px;
  grid-template-areas:
    ${({ hasLabel }) => hasLabel && "'label label label'"}
    'checkbox image details'
    'options options options';

  ${mediaBreakpointUp.md} {
    grid-template-columns: 24px 80px 250px 130px;
    grid-template-areas:
      'checkbox image details ${({ hasLabel }) =>
        hasLabel ? 'label' : 'details'}'
      '. image options options';
  }
`;

export const LabelWrapper = styled.div`
  grid-area: label;

  justify-self: start;

  ${mediaBreakpointUp.md} {
    justify-self: end;
  }
`;

export const CheckboxWrapper = styled.div`
  grid-area: checkbox;
`;

export const ImageWrapper = styled.div`
  grid-area: image;
`;

export const DetailsWrapper = styled.div`
  grid-area: details;
`;

export const OptionsWrapper = styled.div`
  grid-area: options;
`;

export const ReturnQuantityWrapper = styled.div`
  width: 100%;

  ${mediaBreakpointUp.md} {
    width: 115px;
  }
`;

export const ProductName = styled.div<{
  size: 'md' | 'sm';
}>`
  font-weight: 700;
  gap: 8px;
  ${({ size }) => {
    switch (size) {
      case 'md':
        return `
          font-size: 20px;
          line-height: 24px;
          display: flex;
          justify-content: space-between;
          
        `;
      case 'sm':
      default:
        return `
          font-size: 16px;
          line-height: 24px;
          display: flex;
          justify-content: space-between;
        `;
    }
  }}
`;

export const ItemInfo = styled.div`
  font-size: 16px;
  line-height: 24px;
  font-weight: normal;
  overflow-wrap: break-word;
  word-break: break-all;
  flex-shrink: 0;
`;

export const ItemInfoLabel = styled.span`
  font-weight: 700;
`;

export const ProductNameItem = styled.span`
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
`;
